import Layout from "../../layouts/layout";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { DatePicker } from "react-advance-jalaali-datepicker";
import { useEffect, useState } from "react";
import { createSingleUser, storeSingleUsers, } from "../../api/users";
import MainPageLayout from "../../components/main-page-layout/mainPageLayout";
import { useRequestProcessor } from "../../api/requestProcessor";
import { useNavigate } from "react-router-dom";
import { storeSingleTemplates } from "../../api/kavenegar";

const CreateTemplate = () => {

    const { Query, Mutate } = useRequestProcessor();
    const navigate = useNavigate()
    const { mutate } = Mutate(
        "storeSingleTemplate",
        storeSingleTemplates,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
                    autoClose: 2500,
                    pauseOnHover: false
                })
                setTimeout(() => { navigate("/admin/kavenegar") }, 3000)
            }
        }

    )

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();




    async function onHookFormhandler(data) {
        mutate(data)
    }



    return (
        <Layout title="ایجاد قالب">
            <MainPageLayout title={"ایجاد قالب جدید"} >
                <form onSubmit={handleSubmit((data) => onHookFormhandler(data))} className='flex flex-col'>
                    {/* <h1 className="text-[1.5rem]">ایجاد کاربر جدید</h1> */}
                    <div className="flex wsm:flex-col">
                        <div className='flex-col my-4 !w-full'>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.title && "text-red-500"}`}>عنوان :</p>
                                <input type="text" {...register("title", { required: true })} className='form-input !w-full' placeholder='عنوان' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.name && "text-red-500"}`}>عنوان کاوه نگار (به انگلیسی) :</p>
                                <input type="text" {...register("name", { required: true })} className='form-input !w-full' placeholder='به انگلیسی وارد کنید ' />
                            </div>

                        </div>
                        <div className="flex-col my-4 !w-full mr-2">
                            <div className='flex flex-col my-3'>
                                <p className={`pr-3 pb-1 ${errors.message && "text-red-500"}`}>پیغام :</p>
                                <textarea type="text" rows={5}  {...register("message", { required: true })} className={`form-input !w-full`} placeholder='پیغام خود را  به همراه توکن وارد کنید' />
                            </div>
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default CreateTemplate